var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDrawerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M29.818352,20.8337209 L9.06568369,39.4243981 C8.38767729,40.0302636 8,40.8966749 8,41.7998271 C8,42.5875613 8.29197133,43.3438652 8.82596193,43.9340482 C10.0208062,45.2554464 12.0937171,45.3637423 13.4254287,44.1725207 L30.3879511,28.9782259 L31.9996243,27.5345587 L33.611402,28.978108 L50.5763262,44.1723275 C51.9064875,45.3635423 53.9786416,45.2552608 55.173318,43.9340482 L55.2282436,43.8726425 L55.3275085,43.7545944 C55.7585271,43.2054303 55.991919,42.5498842 56,41.8625569 L55.9943108,41.6323731 C55.9486343,40.7739059 55.5775837,39.9987934 54.9366812,39.4246203 L34.1786504,20.8342742 C32.9361715,19.7220008 31.0619631,19.7220008 29.818352,20.8337209 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDrawerIcon);
export default __webpack_public_path__ + "static/media/close-drawer-icon.ea8ff6bf8868c6136d81f0ce99a45a52.svg";
export { ForwardRef as ReactComponent };